// A mock function to mimic making an async request for data
import { IStandardAPIResponse } from "definitions/resp";
import { IAddress, IUserAddress } from "../../address";
import { handleErrorResp, httpClient } from "../UtilServices";



export async function searchAddress(
    obj: any
): Promise<IStandardAPIResponse<Array<IUserAddress>>> {
    try {
        // Explicitly provide the generic type for httpClient
        let res = await httpClient<IUserAddress[]>('user-address', 'GET', obj);
        return res;
    } catch (err: any) {
        // Correct catch block for searchAddress
        const errorResponse: IStandardAPIResponse<Array<IUserAddress>> = {
            success: false,
            message: err?.response?.data?.message || err?.message || "An unknown error occurred during address search.",
            data: [] // Return empty array for list response
        };
        return errorResponse;
    }
}

export async function getMyDefaultAddress(): Promise<
    IStandardAPIResponse<IUserAddress>
> {
    try {
        // Explicitly provide the generic type for httpClient
        let res = await httpClient<IUserAddress>(`my-default-address`, 'GET');
        return res;
    } catch (err: any) {
        // Correct catch block for getMyDefaultAddress
        const errorResponse: IStandardAPIResponse<IUserAddress> = { // Correct generic type
            success: false,
            message: err?.response?.data?.message || err?.message || "An unknown error occurred fetching default address.", // Correct message
            data: {} as IUserAddress // Return empty object for single address response
        };
        return errorResponse;
    }
}

export async function addAAddress(
    obj: any
): Promise<IStandardAPIResponse<IUserAddress>> {
    try {
        // Explicitly provide the generic type for httpClient
        let res = await httpClient<IUserAddress>(`user-address`, 'PUT', obj);
        return res;
    } catch (err: any) {
        const errorResponse: IStandardAPIResponse<IUserAddress> = {
            success: false,
            // Correct catch block for addAAddress
            message: err?.response?.data?.message || err?.message || "An unknown error occurred adding address.", // Correct message
            data: {} as IUserAddress
        };
        return errorResponse;
    }
}

export async function updateAAddress(
    addressId: string,
    obj: any
): Promise<IStandardAPIResponse<IUserAddress>> {
    try {
        // Explicitly provide the generic type for httpClient
        let res = await httpClient<IUserAddress>(`user-address/${addressId}`, 'PATCH', obj);
        return res;
    } catch (err: any) {
        const errorResponse: IStandardAPIResponse<IUserAddress> = {
            success: false,
            // Correct catch block for updateAAddress
            message: err?.response?.data?.message || err?.message || "An unknown error occurred updating address.", // Correct message
            data: {} as IUserAddress
        };
        return errorResponse;
    }
}

export async function deleteAAddress(
    addressId: string
): Promise<IStandardAPIResponse<IUserAddress>> {
    try {
        // Explicitly provide the generic type for httpClient
        let res = await httpClient<IUserAddress>(`user-address/${addressId}`, 'DELETE');
        return res;
    } catch (err: any) {
        const errorResponse: IStandardAPIResponse<IUserAddress> = {
            success: false,
            // Correct catch block for deleteAAddress
            message: err?.response?.data?.message || err?.message || "An unknown error occurred deleting address.", // Correct message
            data: {} as IUserAddress
        };
        return errorResponse;
    }
}